import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../../common/error/error.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationResponse, EmployeeInfo } from 'src/app/model-generated/models';
import { lookup } from 'src/constants/Lookup';
import { i18n } from 'src/constants/I18N';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    standalone: false
})
export class LoginFormComponent implements OnInit {

  constructor(
    public fb: FormBuilder,
    public http: HttpClient,
    public appService: AppService,
    public errorService: ErrorService,
    public router: Router,
    public cookieService: CookieService
  ) { }

  @Input() onAfterLogin: () => void;

  public formGroup: FormGroup
  public loginErrorMessage: string;

  public forgotPassword: boolean;

  ngOnInit(): void {
    this.initFormGroup()
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      login: [ "", Validators.required ],
      password: [ "", Validators.required ]
    })
  }

  async submitForm() {
    this.loginErrorMessage = null;
    this.appService.setIsLoading(true);
    this.http.post<AuthenticationResponse>(environment.authUrl + "/authenticate", this.formGroup.value)
      .subscribe({
        next: async (res) => {
          this.cookieService.set("token", res.jwt);
          let employeeInfo = await this.getEmployeeInfo();
          await this.appService.setAuth(true, res.jwt, employeeInfo);
          await i18n.init();
          await lookup.init();
          this.appService.setIsLoading(false);
          this.onAfterLogin();
        },
        error: (error: HttpErrorResponse) => {
          this.loginErrorMessage = error.error?.message || 'Неверная комбинация логина и пароля';
          this.appService.setIsLoading(false);
        }
      })
  }

  async getEmployeeInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<EmployeeInfo>(environment.authUrl + "/employee")
          .subscribe({
            next: res => {
              resolve(res);
            },
            error: (error) => this.errorService.showError(error)
          })
    })
  }
}
